import { render, staticRenderFns } from "./StepSchedulesPricing.vue?vue&type=template&id=0a4ab150"
import script from "./StepSchedulesPricing.vue?vue&type=script&lang=js"
export * from "./StepSchedulesPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4ab150')) {
      api.createRecord('0a4ab150', component.options)
    } else {
      api.reload('0a4ab150', component.options)
    }
    module.hot.accept("./StepSchedulesPricing.vue?vue&type=template&id=0a4ab150", function () {
      api.rerender('0a4ab150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/translations/StepSchedulesPricing.vue"
export default component.exports